module.exports = __webpack_public_path__ + "static/media/be.0d72048b.svg";